var alignment_rtlignore_default = {
  "alignLeft": "-zNl6",
  "textWrapNowrap": "P5Npf",
  "alignRight": "_1UfgL",
  "alignCenter": "_8BlR9",
  "sizeFullWidth": "NjdU7",
  "renderedInTable": "_4yBkF",
  "sizeOriginal": "yaNnp",
  "sizeContent": "U15fi",
  "sizeSmall": "iwxh3",
  "sizeSmallCenter": "SwA0T",
  "flex": "Ha6N8",
  "LEFT": "hu3lv",
  "CENTER": "FXVex",
  "RIGHT": "vXXDY",
  "AUTO": "L7zaT",
  "JUSTIFY": "SvPsN"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
